'use client';

import { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import useBreakpoint from '@/utils/hooks/useBreakpoint';

import CanvasWrapper from './CanvasWrapper';
import OptimizedDitherImage, { OptimizedDitherImageProps } from './OptimizedDitherImage';

interface LazyDitherProps extends OptimizedDitherImageProps {
  className?: string;
}

const LazyDither = ({ className, ...ditherProps }: LazyDitherProps) => {
  const { isBelowTablet } = useBreakpoint();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Skip rendering on mobile devices
    if (isBelowTablet) {
      return undefined;
    }

    if ('requestIdleCallback' in window) {
      const timer = requestIdleCallback(
        () => {
          setShouldRender(true);
        },
        { timeout: 2000 }
      );

      return () => cancelIdleCallback(timer);
    }

    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 100);

    return () => clearTimeout(timer);
  }, [isBelowTablet]);

  // Don't render dither on mobile or before idle callback
  if (!shouldRender || isBelowTablet) {
    return <Box className={className} />;
  }

  return (
    <CanvasWrapper className={className}>
      <OptimizedDitherImage {...ditherProps} />
    </CanvasWrapper>
  );
};

export default LazyDither;
